import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__mountains" aria-hidden="true">
        <svg viewBox="0 0 1440 120" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0,120 L0,80 L120,20 L240,60 L360,10 L480,50 L600,0 L720,40 L840,5 L960,45 L1080,15 L1200,55 L1320,25 L1440,60 L1440,120 Z" fill="#1B2A4A" opacity="0.3"/>
          <path d="M0,120 L0,90 L180,40 L360,75 L540,30 L720,65 L900,25 L1080,60 L1260,35 L1440,70 L1440,120 Z" fill="#1B2A4A" opacity="0.5"/>
          <path d="M0,120 L0,100 L240,60 L480,85 L720,50 L960,80 L1200,55 L1440,80 L1440,120 Z" fill="#1B2A4A"/>
        </svg>
      </div>

      <div className="footer__body">
        <div className="container">
          <div className="footer__grid">
            <div className="footer__brand">
              <div className="footer__logo">
                <span>🐾</span>
                <div>
                  <div className="footer__logo-sub">Run Around</div>
                  <div className="footer__logo-main">Dog Town Rescue</div>
                </div>
              </div>
              <p className="footer__tagline">A Cause for Healing Paws</p>
              <p className="footer__desc">
                A volunteer-run rescue dedicated to finding forever homes for dogs in need across New Mexico.
              </p>
            </div>

            <div className="footer__col">
              <h4>Quick Links</h4>
              <ul>
                <li><Link to="/dogs">Available Dogs</Link></li>
                <li><Link to="/events">Events</Link></li>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/memorial">Memorial Wall</Link></li>
                <li><Link to="/donate">Donate</Link></li>
              </ul>
            </div>

            <div className="footer__col">
              <h4>Contact Us</h4>
              <ul className="footer__contact">
                <li>
                  <span>📧</span>
                  <a href="mailto:RunAroundDogTown@gmail.com">RunAroundDogTown@gmail.com</a>
                </li>
                <li>
                  <span>📞</span>
                  <span>Chris: <a href="tel:5757708688">575-770-8688</a></span>
                </li>
                <li>
                  <span>📞</span>
                  <span>Sharon: <a href="tel:5757797721">575-779-7721</a></span>
                </li>
                <li>
                  <span>📍</span>
                  <span>New Mexico</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="footer__bottom">
            <p>© {new Date().getFullYear()} Run Around Dog Town Rescue. All rights reserved.</p>
            <Link to="/admin" className="footer__admin-link">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
